import { render, staticRenderFns } from "./changephone.vue?vue&type=template&id=15d704ec&scoped=true&"
import script from "./changephone.vue?vue&type=script&lang=js&"
export * from "./changephone.vue?vue&type=script&lang=js&"
import style0 from "./changephone.vue?vue&type=style&index=0&id=15d704ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d704ec",
  null
  
)

export default component.exports